export default "__VITE_ASSET__I0Ix9PDH__"